import { ApiBuilderType } from 'modules/common/types'
import { SendPushNotificationType } from 'modules/push-notifications/types'

export const create = (builder: ApiBuilderType) =>
	builder.mutation<void, SendPushNotificationType>({
		query: data => {
			return {
				url: '/push',
				method: 'POST',
				body: data,
			}
		},
	})
